module.exports = __webpack_public_path__ + "27d4e9c7ed9d7606381c153200920989.pdf";